/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_SUBSCRIPTIONS_BEGIN,
  LIST_SUBSCRIPTIONS_SUCCESS,
  LIST_SUBSCRIPTIONS_ERR,

  CREATE_SUBSCRIPTION_BEGIN,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_ERR,

  UPDATE_SUBSCRIPTION_BEGIN,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_ERR,

  DELETE_SUBSCRIPTION_BEGIN,
  DELETE_SUBSCRIPTION_SUCCESS,
  DELETE_SUBSCRIPTION_ERR,

  BLOCK_SUBSCRIPTION_BEGIN,
  BLOCK_SUBSCRIPTION_SUCCESS,
  BLOCK_SUBSCRIPTION_ERR,

  UNBLOCK_SUBSCRIPTION_BEGIN,
  UNBLOCK_SUBSCRIPTION_SUCCESS,
  UNBLOCK_SUBSCRIPTION_ERR,

  GET_SUBSCRIPTION_DETAILS_BEGIN,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateSubscription: false,
  errorCreateSubscription: "",
  loadingUpdateSubscription: false,
  errorUpdateSubscription: "",
  subscriptions: [],
  totalSubscriptions: 0,
  totalSubscriptionsPages: 0,
  loadingDeleteSubscription: false,
  errorDeleteSubscription: "",
  loadingBlockSubscription: false,
  errorBlockSubscription: null,
  loadingUnblockSubscription: false,
  errorUnblockSubscription: null,
  loadingGetSubscriptionDetails: false,
  errorGetSubscriptionDetails: null,
  subscriptionDetails: {},
};

const subscriptionsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        loadingCreateSubscription: true,
        errorCreateSubscription: "",
      };
    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: [...state.subscriptions, data],
        loadingCreateSubscription: false,
        errorCreateSubscription: "",
      };
    case CREATE_SUBSCRIPTION_ERR:
      return {
        ...state,
        errorCreateSubscription: err,
        loadingCreateSubscription: false,
      };

    case LIST_SUBSCRIPTIONS_BEGIN:
      return {
        ...state,
        loadingListSubscriptions: true,
        errorListSubscriptions: false,
        totalSubscriptions: 0,
        totalSubscriptionsPages: 0,
      };
    case LIST_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptions: [...data.results],
        loadingListSubscriptions: false,
        errorListSubscriptions: null,
        totalSubscriptions: data.total_count,
        totalSubscriptionsPages: data.total_pages,
      };
    case LIST_SUBSCRIPTIONS_ERR:
      return {
        ...state,
        errorListSubscriptions: err,
        loadingListSubscriptions: false,
        totalSubscriptions: 0,
        totalSubscriptionsPages: 0,
      };

    case UPDATE_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        loadingUpdateSubscription: true,
        errorUpdateSubscription: false,
      };
    case UPDATE_SUBSCRIPTION_SUCCESS:
      const updatedSubscriptions = state.subscriptions.map((subscription) =>
        subscription.id === data.id
          ? { ...subscription, ...data }
          : subscription
      );
      return {
        ...state,
        subscriptions: updatedSubscriptions,
        loadingUpdateSubscription: false,
        errorUpdateSubscription: null,
      };
    case UPDATE_SUBSCRIPTION_ERR:
      return {
        ...state,
        errorUpdateSubscription: err,
        loadingUpdateSubscription: false,
      };

    case DELETE_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        loadingDeleteSubscription: true,
        errorDeleteSubscription: null,
      };
    case DELETE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: state.subscriptions.filter(
          (subscription) => subscription.id !== data.id
        ),
        loadingDeleteSubscription: false,
        errorDeleteSubscription: null,
      };
    case DELETE_SUBSCRIPTION_ERR:
      return {
        ...state,
        errorDeleteSubscription: err,
        loadingDeleteSubscription: false,
      };

    case BLOCK_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        loadingBlockSubscription: true,
        errorBlockSubscription: null,
      };
    case BLOCK_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loadingBlockSubscription: false,
        errorBlockSubscription: null,
      };
    case BLOCK_SUBSCRIPTION_ERR:
      return {
        ...state,
        errorBlockSubscription: err,
        loadingBlockSubscription: false,
      };

    case UNBLOCK_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        loadingUnblockSubscription: true,
        errorUnblockSubscription: null,
      };
    case UNBLOCK_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loadingUnblockSubscription: false,
        errorUnblockSubscription: null,
      };
    case UNBLOCK_SUBSCRIPTION_ERR:
      return {
        ...state,
        loadingUnblockSubscription: false,
        errorUnblockSubscription: err,
      };

    case GET_SUBSCRIPTION_DETAILS_BEGIN:
      return {
        ...state,
        subscriptionDetails: {},
        loadingGetSubscriptionDetails: true,
        errorGetSubscriptionDetails: null,
      };
    case GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionDetails: data,
        loadingGetSubscriptionDetails: false,
        errorGetSubscriptionDetails: null,
      };
    case GET_SUBSCRIPTION_DETAILS_ERR:
      return {
        ...state,
        subscriptionDetails: {},
        loadingGetSubscriptionDetails: false,
        errorGetSubscriptionDetails: err,
      };

    default:
      return state;
  }
};

export { subscriptionsReducer };
